import { Component, OnInit } from '@angular/core';
import { orgService } from '../org.service';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { OrgContactsService } from '../org-contacts/org-contacts.service';
import { FinanceSettingsComponent } from '../../common/finance-settings/finance-settings.component';
import { InvoiceComponent } from '../../common/finance-settings/invoice/invoice.component';

@Component({
  selector: 'app-org-finance',
  standalone: true,
  imports: [FinanceSettingsComponent, NgbNavModule, InvoiceComponent],
  templateUrl: './org-finance.component.html',
  styleUrl: './org-finance.component.scss'
})

export class OrgFinanceComponent implements OnInit{
  
  public modName = 'properly-org';
  public orgObject = null;
  public modId = null
  public projectArray : Array<any> = [];
  public orgDropdownArray : Array<any> = [];
  public orgProjectDropdown: Array<any> = [];
  active = 1;
  contacts = [];
  constructor( private orgservice: orgService ,
  private orgcontactservice: OrgContactsService){
  }

  ngOnInit(): void {
    this.orgservice.orgdetails.subscribe((data) => {
     this.orgObject = data;
     if(this.orgObject){
      this.orgservice.getUserprojects(this.orgObject?.orgDetails?.orgInfo?.oId).subscribe((data) => {
        this.projectArray = data;
        this.orgDropdownArray = [];
        this.projectArray.forEach((projectData) => {
           this.orgDropdownArray.push({
            id: projectData?.projInfo?.prjtID,
            name : projectData?.projInfo?.projName,
            type: 'project'
           });
        });
      });
    }
    });
  }
}
